<template>
  <SigninBody/>
</template>

<script>
// @ is an alias to /src
import SigninBody from '@/components/SigninBody.vue'

export default {
  name: 'SigninView',
  components: {
    SigninBody
  }
}
</script>
